// extracted by mini-css-extract-plugin
export default {"Poll":"styles_Poll__bxGRy","container":"styles_container__-hZxU","footer":"styles_footer__8cv6L","totalVotes":"styles_totalVotes__SbqNP"};